import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <div className="bg-navy text-cream w-full py-12" data-id="element-90">
      <Section data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <span className="text-terracotta font-medium tracking-widest uppercase text-sm" data-id="element-93">
            El Mecanismo Único
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold mt-4 mb-6 text-white" data-id="element-94">
            Protocolo 5x5
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-95">
            5 minutos. 5 acciones. Siempre igual.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-96">
          <div className="space-y-6" data-id="element-97">
            <p className="text-lg text-cream/90 leading-relaxed" data-id="element-98">
              Cuando estás en pico, tu sistema nervioso no necesita un discurso.{' '}
              <strong className="text-terracotta" data-id="element-99">
                Necesita señales físicas de seguridad.
              </strong>
            </p>
            <p className="text-lg text-cream/90 leading-relaxed" data-id="element-100">
              Por eso este kit no empieza con “analizar”. Empieza con 5 acciones
              en un orden exacto:
            </p>

            <div className="space-y-4 mt-8" data-id="element-101">
              {[{
              step: '1',
              title: 'Respiración',
              desc: '(ritmo, no profundidad)'
            }, {
              step: '2',
              title: 'Anclaje sensorial',
              desc: '(salir del cine mental)'
            }, {
              step: '3',
              title: 'Descarga física breve',
              desc: '(cerrar el circuito)'
            }, {
              step: '4',
              title: 'Frase de control',
              desc: '(una línea, sin debatir)'
            }, {
              step: '5',
              title: 'Microdecisión',
              desc: '(volver a la vida real)'
            }].map(item => <div key={item.step} className="flex items-center gap-4 bg-white/5 p-4 rounded-lg border border-white/10" data-id="element-102">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-terracotta text-white font-bold shrink-0" data-id="element-103">
                    {item.step}
                  </span>
                  <div data-id="element-104">
                    <span className="font-bold text-white" data-id="element-105">{item.title}</span>{' '}
                    <span className="text-cream/70" data-id="element-106">{item.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="bg-cream/5 p-8 rounded-2xl border border-cream/10" data-id="element-107">
            <h3 className="font-serif text-2xl text-white mb-6" data-id="element-108">
              No es magia. Es entrenamiento.
            </h3>
            <p className="text-cream/80 mb-6" data-id="element-109">
              Funciona porque es repetible. No depende de motivación, ni
              espiritualidad, ni apps. Es secuencia, no inspiración.
            </p>
            <div className="space-y-4" data-id="element-110">
              <div className="p-4 bg-navy/50 rounded-lg border-l-4 border-terracotta" data-id="element-111">
                <h4 className="font-bold text-white mb-1" data-id="element-112">
                  “Pero yo ya probé respirar…”
                </h4>
                <p className="text-sm text-cream/70" data-id="element-113">
                  Sí. Y probablemente lo hiciste en el peor formato posible:
                  profundo, rápido, sin estructura, hasta marearte. Acá vas a
                  usar respiración como se usa en un protocolo: para bajar el
                  ritmo, no para “sentirte espiritual”.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}